exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input {\n  display: none; }\n\n.btn-select-file {\n  font-weight: 500;\n  font-size: 14px;\n  margin-top: -15px;\n  padding: 3px 10px; }\n\n.btn-select-file {\n  color: white;\n  background-color: #49494A;\n  border-color: #49494A; }\n\n.fa-cloud-upload {\n  font-size: 20px;\n  padding-right: 10px;\n  margin-top: 1px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Biziclick/bizisystem/src/app/shared/select-file/select-file.component.scss
// module id = ../../../../../src/app/shared/select-file/select-file.component.scss
// module chunks = main